export default {
  pageTitle: '熱交換器製作',
  metaDescription: 'TEFは銅ニッケル、チタン、デュプレックスステンレスを用いて、シェルアンドチューブ式熱交換器、リボイラー、コンデンサー、クーラーを製作しています。',
  sidebar: {
    title: '製作リスト',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: '塔槽製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  product: {
    name: '熱交換器',
    desc: '以下は、当社の熱交換器製作における各種材質・タイプ・仕様の実績カタログです。',
  },
};
